import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

import { ErrorStrings, ValidationPatterns } from 'src/app/constants/form.constants';
import { User, UserTelephone, UserTelephoneType } from 'src/app/interfaces/user';
import { UserService } from 'src/app/services/user/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Alert } from 'src/app/interfaces/alert';
import { NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { RedirectionParams, RedirectionService } from 'src/app/services/redirection/redirection.service';
import { isPlatformBrowser } from '@angular/common';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-update-telephone',
  templateUrl: './update-telephone.component.html',
  styleUrls: ['./update-telephone.component.scss']
})
export class UpdateTelephoneComponent implements OnInit {
  errorStrings = ErrorStrings;
  loading = false;
  alert: Alert = null;
  userTelephoneType = UserTelephoneType;
  user: User;
  redirectParams?: RedirectionParams;
  secondaryTelephoneDeleted = false;
  isBrowser: boolean;
  useRebrandedLayout: boolean;

  updatedMainPhone = '';
  updatedSecondaryPhone = '';

  existingTelephones: { mainPhoneNumber: string; secondaryPhoneNumber: string };

  validationPatterns = ValidationPatterns;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private redirectionService: RedirectionService,
    private featureFlagService: FeatureFlagsService,
    @Inject(PLATFORM_ID) private platformId: Object,
    
  ) {
    if (this.route && this.route.snapshot) {
      this.user = this.route.snapshot.data.user as User;
    }
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');
  }

  // TODO: When we have more time, we'll need to move the error handling inside the service
  save(form: NgForm) {
    this.closeAlert();
    this.loading = true;

    // Preparing payload to be sent
    const mainPhoneNumber = this.updatedMainPhone.trim() || this.existingTelephones.mainPhoneNumber || '';
    const secondaryPhoneNumber = this.updatedSecondaryPhone.trim() || this.existingTelephones.secondaryPhoneNumber || '';

    this.userService.saveTelephoneNumbers(mainPhoneNumber, secondaryPhoneNumber)
      .subscribe({
        next: updatedUser => {
          // It will get updated user data and the telephone numbers,
          // will assign those value to the non editable input fields
          // and will reset the new phone numbers fields
          this.user = updatedUser;
          this.existingTelephones = this.getExistingTelephones();
          form.controls.phoneNew.reset();
          form.controls.phone2New.reset();
          this.updatedMainPhone = '';
          this.updatedSecondaryPhone = '';
          this.secondaryTelephoneDeleted = false;
          this.loading = false

          this.alert = {
            type: 'success',
            message: 'Your contact numbers have been updated.'
          };

          this.trackEvent('phonechange::updated');

          if (this.redirectParams) {
            this.router.navigate(this.redirectParams.l, { queryParams: this.redirectParams.q, fragment: this.redirectParams.f });
          }
        },
        error: err => {
          if (err instanceof HttpErrorResponse && err.status === 400) {
            this.loading = false
            this.alert = {
              type: 'danger',
              message: 'There was a problem updating your telephone number.'
            };
          } else {
            this.loading = false
            this.alert = {
              type: 'danger',
              message: 'An error has occurred. Please try again later.'
            };
          }
        }
      })
  }

  removeSecondaryPhoneNumber() {
    this.existingTelephones.secondaryPhoneNumber = '';
    this.secondaryTelephoneDeleted = true;
  }

  closeAlert() {
    this.alert = null;
  }

  trackEvent(event: string) {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }

  // Returns an array of type UserTelephone as empty objects or with the existing telephones retrieved from
  // the user object ordered by UserTelephoneType
  getExistingTelephones(): { mainPhoneNumber: string, secondaryPhoneNumber: string } {
    return {
      mainPhoneNumber: this.user.contact.mainPhoneNumber || '',
      secondaryPhoneNumber: this.user.contact.secondaryPhoneNumber || ''
    }
  }

  // TODO: directive to remove spaces from telephone and format input?

  ngOnInit(): void {
    this.existingTelephones = this.getExistingTelephones();

    // Setting redirection to be used when telephone is saved or when pressing back
    if (this.route && this.route.snapshot) {
      this.redirectParams = this.redirectionService.getParams(this.route.snapshot.queryParams.r);
    }
   
  }
}
